import React from 'react';
import { padraoInfoVariant } from './utils';

/**
 * "?" ao lado do cabeçalho Padrão: abre o PadraoInfoModal com as faixas do tipo de
 * empreendimento da tabela. Porte do botão que existe nas tabelas do mapa Google.
 *
 * Não renderiza nada quando o título não tem faixas a explicar (HORIZONTAL/loteamentos)
 * nem quando o pai não passa `onShow`.
 *
 * @param {{title: string, color: string, onShow: (variante: string) => void}} props
 */
export default function PadraoInfoButton({ title, color, onShow }) {
    const variante = padraoInfoVariant(title);

    if (!variante || !onShow) return null;

    return (
        <button
            type="button"
            className="mapbox-padrao-info-btn"
            style={{ color: '#fff' }}
            onClick={() => onShow(variante)}
            title="Como o padrão é classificado"
            aria-label="Como o padrão é classificado"
        >
            <i className="far fa-question-circle"></i>
        </button>
    );
}
